var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"pull-right"},[_c('a',{staticClass:"btn submit",attrs:{"href":"#"},on:{"click":_vm.toggleSearch}},[_c('i',{staticClass:"icon-magnifier"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }